<template>
  <div class="login-dialog">
    <div class="login-dialog-wrapper">
      <el-dialog
        :visible.sync="dialogVisible"
        width="900px"
        :modal-append-to-body="false"
        :close-on-click-modal="false"
        custom-class="login"
      >
        <div class="login-wrapper flex-start">
          <div class="left-content">
            <img src="../../../../assets/home/login.webp" alt="登录背景图" />
          </div>
          <div class="right-content">
            <h3>登录</h3>
            <div class="form-wrapper">
              <el-form
                ref="loginForm"
                :model="loginForm"
                :rules="loginRules"
                class="login-form"
                auto-complete="on"
                label-position="left"
              >
                <el-form-item prop="account">
                  <span class="svg-container">
                    <svg-icon icon-class="user" />
                  </span>
                  <el-input
                    ref="account"
                    v-model="loginForm.account"
                    placeholder="账号/电子邮箱/手机"
                    name="account"
                    type="text"
                    autocomplete="off"
                  />
                </el-form-item>

                <el-form-item prop="password">
                  <span class="svg-container">
                    <svg-icon icon-class="password" />
                  </span>
                  <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="loginForm.password"
                    :type="passwordType"
                    placeholder="请输入密码"
                    name="password"
                    autocomplete="off"
                    @keyup.enter.native="handleLogin"
                  />
                  <span class="show-pwd" @click="showPwd">
                    <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
                  </span>
                </el-form-item>

                <el-button
                  :loading="loading"
                  type="primary"
                  style="width: 100%; margin-bottom: 30px"
                  @click.native.prevent="handleLogin"
                >
                  立即登录
                </el-button>

                <div class="tips">
                  <span @click="openForgetPass">忘记密码?</span>
                  <span @click="openRegister">立即注册</span>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import event from '@/utils/event';
import register from '@/components/common/dialog/register/index'
export default {
  inject: ['reload'],
  data() {
    return {
      dialogVisible: false,
      loginForm: {
        account: '',
        password: '',
      },
      loginRules: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
      },
      loading: false,
      passwordType: 'password',
    };
  },
  components: {
    register
  },
  methods: {
    ...mapActions(['login', 'getDevelopInfo', 'getDashboardStatistics']),
    open() {
      this.dialogVisible = true;

      // 打开前清除验证提示信息
      this.$refs['loginForm'] && this.$refs['loginForm'].clearValidate();
    },
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = '';
      } else {
        this.passwordType = 'password';
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    // 登录
    handleLogin() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let param = {
            account: this.loginForm.account,
            password: this.$md5(this.loginForm.password),
          };
          try {
            const res = await this.login(param);
            if (res.code === 0) {
              await this.getDevelopInfo();
              await this.getDashboardStatistics();
              this.dialogVisible = false;
              this.$router.push('/');
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.loading = false;
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 打开注册
    openRegister() {
      this.dialogVisible = false;
      event.$emit('openRegister');
    },

    // 打开忘记密码
    openForgetPass() {
      this.dialogVisible = false;
      event.$emit('openResetPass');
    },
  },
};
</script>

<style lang="scss" scoped>
.login-dialog-wrapper {
  &::v-deep {
    .el-dialog__header {
      padding: 0px;
    }
    .el-dialog__body {
      padding: 0px;
    }
    .el-input__inner {
      border: none;
      height: 45px;
      line-height: 45px;
      padding: 0px;
      -webkit-appearance: none;
    }
    .el-button--primary {
      background-color: #4173fb;
      border-radius: 0;
      outline: none;
      border: none;
      height: 47px;
    }
  }
  .login-wrapper {
    box-sizing: border-box;
    width: 100%;
    height: 500px;
    .left-content {
      width: 380px;
      height: 100%;
      img {
        max-width: 100%;
      }
    }
    .right-content {
      box-sizing: border-box;
      width: 520px;
      height: 100%;
      padding: 44px 40px;
      h3 {
        text-align: center;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 35px;
        margin-bottom: 64px;
      }
      .form-wrapper {
        .login-form {
          width: 100%;
          position: relative;
          overflow: hidden;
          .el-input {
            display: inline-block;
            height: 47px;
            width: 80%;
          }

          .el-form-item {
            border: 1px solid #e7e7e7;
            background: #fff;
            // border-radius: 4px;
            color: #999999;
            height: 47px;
            box-sizing: border-box;
            margin-bottom: 64px;
          }
          .svg-container {
            padding: 0 10px;
            color: #999;
            vertical-align: middle;
            width: 30px;
            display: inline-block;
            text-align: center;
          }
          .show-pwd {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 16px;
            color: #999;
            cursor: pointer;
            user-select: none;
          }
          .tips {
            text-align: right;
            span {
              font-size: 12px;
              font-weight: 300;
              color: #999999;
              cursor: pointer;
              &:first-of-type {
                margin-right: 15px;
              }
            }
          }
        }
      }
    }
  }
}
</style>
